import React, { useState } from 'react';
import api from '../../../api/axios';
import { useAuthStore } from '../../../store';

const AdminAccount: React.FC = () => {
  const { user } = useAuthStore();
  const [form, setForm] = useState({ username: user?.username || '', password: '', password_confirm: '' });
  const [loading, setLoading] = useState(false);

  const save = async () => {
    if (!form.username) { alert('아이디를 입력해주세요.'); return; }
    if (form.password && form.password !== form.password_confirm) {
      alert('비밀번호가 일치하지 않습니다.'); return;
    }
    if (form.password && form.password.length < 4) {
      alert('비밀번호는 4자 이상이어야 합니다.'); return;
    }
    setLoading(true);
    try {
      const data: any = { username: form.username };
      if (form.password) data.password = form.password;
      await api.patch('/api/auth/me/update/', data);
      alert('변경되었습니다. 다시 로그인해주세요.');
    } catch (e) { alert('변경 실패'); }
    setLoading(false);
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title"><span className="icon">🔐</span>관리자 계정 설정</div>
      </div>
      <div className="card" style={{ maxWidth: 480 }}>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label">현재 아이디</label>
            <div style={{ padding: '10px 14px', background: 'var(--gray-50)', borderRadius: 6, fontSize: 13, color: 'var(--text-muted)' }}>
              {user?.username}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">새 아이디</label>
            <input className="form-control" value={form.username} onChange={e => setForm({...form, username: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">새 비밀번호</label>
            <input type="password" className="form-control" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="변경하지 않으면 빈칸" />
          </div>
          <div className="form-group">
            <label className="form-label">비밀번호 확인</label>
            <input type="password" className="form-control" value={form.password_confirm} onChange={e => setForm({...form, password_confirm: e.target.value})} placeholder="비밀번호 재입력" />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button className="btn btn-primary" onClick={save} disabled={loading}>
              {loading ? '저장 중...' : '💾 저장'}
            </button>
          </div>
          <div style={{ marginTop: 16, padding: '10px 14px', background: '#fef3c7', borderRadius: 8, fontSize: 12, color: '#b45309', borderLeft: '3px solid #f59e0b' }}>
            ⚠️ 변경 후 반드시 기억해주세요. 서버 DB에 안전하게 저장됩니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAccount;
